import { render, staticRenderFns } from "./DocumentacionSecciones.vue?vue&type=template&id=03361278&scoped=true"
import script from "./DocumentacionSecciones.vue?vue&type=script&lang=js"
export * from "./DocumentacionSecciones.vue?vue&type=script&lang=js"
import style0 from "./DocumentacionSecciones.vue?vue&type=style&index=0&id=03361278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03361278",
  null
  
)

export default component.exports